// extracted by mini-css-extract-plugin
export default {"container":"TextAreaCustom_container__LGo1I","champ":"TextAreaCustom_champ__vPAMv"};